/*
  Promo kit: product rail (buttons, drag, keyboard) and the dismissible slim banner.
  Everything works as plain content without JavaScript. Safe to load more than once.
*/
(function () {
  /* ---------- Product rail ---------- */
  function initRail(root) {
    if (root.hasAttribute('data-pk-ready')) return;
    var scroller = root.querySelector('[data-pk-scroller]');
    if (!scroller) return;
    root.setAttribute('data-pk-ready', '');
    var prev = root.querySelector('[data-pk-prev]');
    var next = root.querySelector('[data-pk-next]');

    function step() {
      var item = scroller.querySelector('li');
      var gap = parseFloat(getComputedStyle(scroller).columnGap) || 20;
      return item ? item.getBoundingClientRect().width + gap : 300;
    }
    function sync() {
      var max = scroller.scrollWidth - scroller.clientWidth - 2;
      if (prev) prev.disabled = scroller.scrollLeft <= 8;
      if (next) next.disabled = scroller.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
    scroller.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    /* Keyboard: arrows move the rail when it has focus */
    scroller.addEventListener('keydown', function (e) {
      if (e.target !== scroller) return;
      if (e.key === 'ArrowRight') { scroller.scrollBy({ left: step(), behavior: 'smooth' }); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { scroller.scrollBy({ left: -step(), behavior: 'smooth' }); e.preventDefault(); }
    });

    /* Drag to scroll with a mouse (touch already scrolls natively) */
    var down = false, moved = false, startX = 0, startLeft = 0;
    scroller.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = false; startX = e.pageX; startLeft = scroller.scrollLeft;
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; scroller.classList.add('is-grabbing'); }
      if (moved) { scroller.scrollLeft = startLeft - dx * 1.2; e.preventDefault(); }
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false; scroller.classList.remove('is-grabbing');
    });
    // A drag must not count as a click on a book
    scroller.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    scroller.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- Slim banner ---------- */
  function initStrip(root) {
    if (root.hasAttribute('data-pk-ready')) return;
    root.setAttribute('data-pk-ready', '');
    var btn = root.querySelector('[data-pk-dismiss]');
    var key = root.getAttribute('data-pk-key');

    // A pinned banner tells the page how tall it is, so the sticky site header can sit just below it
    if (root.classList.contains('pk-strip--sticky')) {
      var wrap = root.closest('.shopify-section') || root;
      var setOffset = function () {
        var h = root.hidden ? 0 : Math.round(wrap.getBoundingClientRect().height);
        document.documentElement.style.setProperty('--pk-strip-offset', h + 'px');
      };
      setOffset();
      window.addEventListener('resize', setOffset);
      if ('ResizeObserver' in window) new ResizeObserver(setOffset).observe(wrap);
      root.addEventListener('pk:dismissed', setOffset);
    }

    if (!btn || !key) return;
    btn.addEventListener('click', function () {
      root.hidden = true;
      try { window.localStorage.setItem(key, '1'); } catch (e) {}
      root.dispatchEvent(new Event('pk:dismissed'));
    });
  }

  function init() {
    document.querySelectorAll('[data-pk-rail]').forEach(initRail);
    document.querySelectorAll('[data-pk-strip]').forEach(initStrip);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
